import React from 'react';

import BaseIcon, { type BaseIconProps } from '../BaseIcon';

const AlertIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 18 18" fill="none">
      <g clipPath="url(#clip0_11606_267056)">
        <path
          d="M9 6V9M9 12H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11606_267056">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

export default AlertIcon;
